:host {
  display: block;
  font-family: var(--cms-base-font);
}

@include energy-rank-color(8);

.energy-label-element {
  display: inline-flex;
  padding-left: 3px;
  align-items: center;
  height: 3.1875rem;
  margin: 0 0 0.75rem;
}

.energy-label-element.has-label {
  cursor: pointer;
}

.svg-eek-template {
  height: 3.1875rem;
  width: 5.625rem;
}

.energy-letter {
  display: inline-block;
  font-size: 1.875rem;
  padding-left: 0.25rem;
  text-decoration: none;
  color: var(--cms-white);
}

.energy-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 26px 0 26px 14px;
  position: relative;
  left: 14px;
  display: inline-block;
}

.energy-wrapper-inner {
  display: inline-flex;
  padding-left: 3px;
  align-items: center;
  height: 3.1875rem;
}
